import { render, staticRenderFns } from "./Receipts.vue?vue&type=template&id=edb60666&scoped=true&"
import script from "./Receipts.vue?vue&type=script&lang=js&"
export * from "./Receipts.vue?vue&type=script&lang=js&"
import style0 from "./Receipts.vue?vue&type=style&index=0&id=edb60666&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb60666",
  null
  
)

export default component.exports